export var ETempNodePlaceType;
(function (ETempNodePlaceType) {
    ETempNodePlaceType["CINEMA"] = "cinema";
})(ETempNodePlaceType || (ETempNodePlaceType = {}));
export var ETempNodeHostType;
(function (ETempNodeHostType) {
    ETempNodeHostType["CINEMA_BRAND"] = "cinema-brand";
    ETempNodeHostType["STREAMING_SERVICE"] = "streaming";
})(ETempNodeHostType || (ETempNodeHostType = {}));
export var ETempNodeInfoType;
(function (ETempNodeInfoType) {
    ETempNodeInfoType["MOVIE"] = "in_mov";
})(ETempNodeInfoType || (ETempNodeInfoType = {}));
export var ETempListedNodeType;
(function (ETempListedNodeType) {
    ETempListedNodeType["MOVIE_SCREENING"] = "li_mov_scr";
    ETempListedNodeType["MOVIE_STREAMING"] = "li_mov_str";
    ETempListedNodeType["EVENT"] = "li_eve";
    ETempListedNodeType["ACTIVITY"] = "li_act";
})(ETempListedNodeType || (ETempListedNodeType = {}));
export var ETimeRelevance;
(function (ETimeRelevance) {
    ETimeRelevance["BEFORE_ONLY"] = "bef";
    ETimeRelevance["CUSTOM"] = "cus";
    ETimeRelevance["ALL"] = "all";
    ETimeRelevance["UNKNOWN"] = "unk";
})(ETimeRelevance || (ETimeRelevance = {}));
export var ETempListedConsumeType;
(function (ETempListedConsumeType) {
    ETempListedConsumeType["DIGITAL"] = "di";
    ETempListedConsumeType["DELIVERY"] = "de";
    ETempListedConsumeType["AT_PLACE"] = "pl";
})(ETempListedConsumeType || (ETempListedConsumeType = {}));
export var ETempNodeVibescoutSource;
(function (ETempNodeVibescoutSource) {
    ETempNodeVibescoutSource["vibescoutUser"] = "vibescout";
})(ETempNodeVibescoutSource || (ETempNodeVibescoutSource = {}));
